import VacancyCandidates from "./VacancyCandidates";
import { candidates } from "@/api"
import { Link } from "@inertiajs/react";

export default function Show({ match, vacancy_candidates, vacancy_candidates_count }) {
  return (
    <div className="space-y-6">
      <div className="mb-6 text-lg font-medium text-gray-800">
        共匹配到 {vacancy_candidates_count} 位候选人
      </div>
      <div className="grid grid-cols-1 gap-6">
        <VacancyCandidates match={match} vancancyCandidates={vacancy_candidates} />
      </div>
      {/* <div className="flex justify-center mt-6">
        <Link href={candidates.index.path()} className="px-6 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition">
          查看更多候选人
        </Link>
      </div> */}
    </div>
  );
}
